import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TileModule } from '@rogers/cdk/tile';
import { SanitizeUrlPipe } from '../utils/sanitize-url.pipe';

@Component({
  standalone: true,
  imports: [CommonModule, TileModule, SanitizeUrlPipe],
  selector: 'ucx-js-media-card',
  templateUrl: './media-card.component.html',
  styleUrls: ['./media-card.component.scss'],
})
export class MediaCardComponent {
  @Input() src = '';
  @Input() header = '';
  @Input() subHeader = '';
  @Input() alt = '';
  isVideo = false;
}
